import React from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-bootstrap-5';

import { setFilterAttribute } from 'bundles/connect/components/store/actions/criteria';
import type { Criteria } from 'bundles/connect/types';

type BuildingClassInputProps = {
  criteria: Criteria;
  disabled?: boolean;
  setFilterAttribute: (key: string, value: any) => void;
}

function BuildingClassInput({
  criteria,
  disabled = false,
  setFilterAttribute
}: BuildingClassInputProps) {
  return (
    <div>
      <Form.Check
        checked={criteria.buildingClassA || false}
        disabled={disabled}
        id="class_a"
        label="Class A"
        type="checkbox"
        onChange={e => setFilterAttribute('buildingClassA', e.target.checked)}
      />
      <Form.Check
        checked={criteria.buildingClassB || false}
        disabled={disabled}
        id="class_b"
        label="Class B"
        type="checkbox"
        onChange={e => setFilterAttribute('buildingClassB', e.target.checked)}
      />
      <Form.Check
        checked={criteria.buildingClassC || false}
        disabled={disabled}
        id="class_c"
        label="Class C"
        type="checkbox"
        onChange={e => setFilterAttribute('buildingClassC', e.target.checked)}
      />
    </div>
  );
}

const mapStateToProps = ({ criteria }) => ({ criteria });

export default connect(mapStateToProps, { setFilterAttribute })(BuildingClassInput);
